import "./loader.css"

const Loader = () => {
    return (
        <div class="loader"></div>
    )
}
export default Loader